import { UserTypes } from 'types/backend/user';
import { CompanyTypes } from 'types/backyard/company';

type paginatedObjTypes = CompanyTypes | UserTypes;

const calculatePageList = (paginatedItems: paginatedObjTypes[], pageNumber = 1) => {
  if (!paginatedItems.length) return '0';
  if (paginatedItems.length > 19) {
    return `${(pageNumber - 1) * 20 + 1}〜${pageNumber * 20}`;
  }
  return `${(pageNumber - 1) * 20 + 1}〜${(pageNumber - 1) * 20 + paginatedItems.length}`;
};

export default calculatePageList;
